import { call } from 'api/base';

export const ValidtionsAPI = {
  validate_routing_number(token, routing_number, provider) {
    return call(`validations/routing-number/${routing_number}`, 'GET', token, {provider});
  }
}
